export const DOMAIN_LABEL = {
  campaign: 'Campaign',
  transactional: 'Transactional',
  push: 'Push',
  sms: 'SMS',
  automation: 'Automations',
  leads: 'Leads & Demos',
  contacts: 'Contacts & Audiences',
  content: 'Content',
  revenue: 'Revenue',
  people: 'People & Tenants'
};

export const DOMAIN_CARDS = [
  {
    key: 'campaign',
    title: 'Campaign',
    icon: 'campaign',
    headline: { metric: 'open_rate', label: 'Open rate', format: 'percent' },
    supporting: [
      { metric: 'emails_sent', label: 'Emails sent', trend: true },
      { metric: 'click_rate', label: 'Click rate', format: 'percent', trend: true },
      { metric: 'bounce_rate', label: 'Bounce rate', format: 'percent', trend: true, invert: true },
      { metric: 'unsubscribe_rate', label: 'Unsub rate', format: 'percent', invert: true }
    ]
  },
  {
    key: 'transactional',
    title: 'Transactional',
    icon: 'transactional',
    headline: { metric: 'delivery_rate', label: 'Delivery rate', format: 'percent' },
    supporting: [
      {
        metric: 'failure_rate',
        label: 'Failure rate',
        format: 'percent',
        trend: true,
        invert: true
      },
      { metric: 'bounce_rate', label: 'Bounce rate', format: 'percent', invert: true },
      { metric: 'templates_with_issues', label: 'Templates with issues', invert: true },
      { metric: 'tenants_with_high_failure', label: 'Tenants with high failure', invert: true }
    ]
  },
  {
    key: 'push',
    title: 'Push',
    icon: 'mobile_push',
    headline: { metric: 'combined_ctr', label: 'Combined CTR', format: 'percent' },
    supporting: [
      { metric: 'mobile_ctr', label: 'Mobile CTR', format: 'percent', trend: true },
      { metric: 'web_ctr', label: 'Web CTR', format: 'percent', trend: true },
      { metric: 'total_push_sends', label: 'Total sends', trend: true },
      { metric: 'active_sending_tenants', label: 'Active tenants' }
    ]
  },
  {
    key: 'sms',
    title: 'SMS',
    icon: 'sms',
    headline: { metric: 'total_sms_sent', label: 'SMS sent', format: 'count' },
    supporting: [
      { metric: 'delivery_rate', label: 'Delivery rate', format: 'percent', trend: true },
      { metric: 'failure_rate', label: 'Failure rate', format: 'percent', invert: true },
      { metric: 'total_cost', label: 'Cost', format: 'currency' },
      { metric: 'active_sending_tenants', label: 'Active tenants' }
    ]
  },
  {
    key: 'automation',
    title: 'Automations',
    icon: 'automation',
    headline: { metric: 'completion_rate', label: 'Completion rate', format: 'percent' },
    supporting: [
      { metric: 'active_automations', label: 'Active automations' },
      { metric: 'runs_in_period', label: 'Runs in period', trend: true },
      { metric: 'tenant_adoption_rate', label: 'Tenant adoption', format: 'percent' },
      { metric: 'low_completion_automations', label: 'Low completion', invert: true }
    ]
  },
  {
    key: 'leads',
    title: 'Leads & Demos',
    icon: 'lead',
    headline: { metric: 'total_leads', label: 'Total leads', format: 'count' },
    supporting: [
      { metric: 'win_rate', label: 'Win rate', format: 'percent', trend: true },
      { metric: 'response_rate', label: 'Response rate', format: 'percent', trend: true },
      { metric: 'show_rate', label: 'Demo show rate', format: 'percent', trend: true },
      { metric: 'demo_conversion_rate', label: 'Demo conversion', format: 'percent', trend: true }
    ]
  },
  {
    key: 'contacts',
    title: 'Contacts & Audiences',
    icon: 'groups',
    headline: { metric: 'total_active_contacts', label: 'Active contacts', format: 'count' },
    supporting: [
      { metric: 'new_contacts_added', label: 'New contacts', trend: true },
      { metric: 'net_list_growth_rate', label: 'List growth rate', format: 'percent', trend: true },
      { metric: 'platform_bounce_rate', label: 'Bounce rate', format: 'percent', invert: true },
      { metric: 'platform_unsub_rate', label: 'Unsub rate', format: 'percent', invert: true }
    ]
  },
  {
    key: 'content',
    title: 'Content',
    icon: 'blogs',
    headline: { metric: 'posts_published', label: 'Posts published', trend: true },
    supporting: [
      { metric: 'seo_score', label: 'SEO score', format: 'score' },
      { metric: 'pending_review', label: 'Pending review', invert: true },
      { metric: 'avg_word_count', label: 'Avg word count' },
      { metric: 'rejection_rate', label: 'Rejection rate', format: 'percent', invert: true }
    ]
  },
  {
    key: 'revenue',
    title: 'Revenue',
    icon: 'balance',
    headline: { metric: 'current_mrr', label: 'MRR', format: 'currency' },
    supporting: [
      { metric: 'mrr_growth_rate', label: 'MRR growth', format: 'percent', trend: true },
      { metric: 'customer_churn_rate', label: 'Customer churn', format: 'percent', invert: true },
      { metric: 'arpu', label: 'ARPU', format: 'currency' },
      { metric: 'unique_paying_tenants', label: 'Paying tenants' }
    ]
  },
  {
    key: 'people',
    title: 'People & Tenants',
    icon: 'organisation',
    headline: { metric: 'healthy_tenants', label: 'Healthy tenants', format: 'count' },
    supporting: [
      { metric: 'critical_tenants', label: 'Critical', danger: true },
      { metric: 'at_risk_tenants', label: 'At risk', warn: true },
      { metric: 'active_tenants', label: 'Active tenants' },
      { metric: 'new_tenants', label: 'New tenants', trend: true }
    ]
  }
];
